import { render, staticRenderFns } from "./Legend.vue?vue&type=template&id=01846f33&scoped=true&lang=html&"
import script from "./Legend.vue?vue&type=script&lang=js&"
export * from "./Legend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01846f33",
  null
  
)

export default component.exports